import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';
import { TeamRoleResponse } from '../models/team-roles.model';

@Injectable({ providedIn: 'root' })
export class TeamRolesApiService extends ApiService {
  getTeamRoles$(): Observable<TeamRoleResponse[]> {
    return this.get<TeamRoleResponse[]>('/TeamRoles');
  }
}

export const apiTeamRolesProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiTeamRoles.scopes.read],
  },
];